import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';

import { PageSkeleton } from '~/components/common/page-skeleton/page-skeleton';

const ClientVerificationScreen = lazy(
  () => import('~/features/item-setup/pages/client-verification-screen'),
);

export const Route = createFileRoute('/_authenticated/_tenant/item-setup/client-verification')({
  component: () => (
    <Suspense fallback={<PageSkeleton />}>
      <ClientVerificationScreen />
    </Suspense>
  ),
});
